import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class BhGroupInvitations extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'BhGroupInvitations'
  // Define default properties here
  static instanceDefaults() {
    return {
      group_id: null,
      user_id: null,
      invited_by: null,
      token: '',
      status: 'pending',
      expires_at: null,
      accepted_at: null,
      declined_at: null,
      revoked_at: null
    }
  }
}
const servicePath = 'bh-group-invitations';
const servicePlugin = makeServicePlugin({
  Model: BhGroupInvitations,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
